import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.less']
})
export class ErrorpageComponent implements OnInit {
  exception: Error = undefined;
  errorMessage: string = '';
  errorName: string = '';
  stackTrace: string = '';

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.exception = params['error'];
/*
      this.errorName = this.exception.name;
      this.errorMessage = this.exception.name;
      this.stackTrace = this.exception.stack;
*/
      console.log(this.exception);
    });
  }

}
